import React, { useMemo } from 'react';
import OrganizationAnalyticsLineChart from './OrganizationAnalyticsLineChart';
import { formatTimeCategoriesByRange, mapIdsToLabels } from './chartUtils';

const OrganizationInfluencerNonSpendersByTimeChart = ({ data, influencerLabelMap, dateRange, pending }) => {
  const { categories, series } = useMemo(
    () => ({
      categories: formatTimeCategoriesByRange(data?.time || [], dateRange),
      series: (data?.series || []).map(item => ({
        name: mapIdsToLabels([item.influencerId], influencerLabelMap)[0],
        data: item.nonSpenders || [],
      })),
    }),
    [data, influencerLabelMap, dateRange],
  );

  return (
    <OrganizationAnalyticsLineChart
      title="Non-Spenders Over Time"
      subtitle="New non-spending users over time per creator."
      categories={categories}
      series={series}
      pending={pending}
      emptyText="Select one or more creators to load non-spenders over time."
      valueType="number"
    />
  );
};

export default OrganizationInfluencerNonSpendersByTimeChart;
